const formatEuroNumber = (number = 0) => {
	const parseNumber = number === null || number === undefined ? 0 : number;
	return parseNumber.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
};

const javascriptDecimalSum = (val1 = 0, val2 = 0) => {
	return (val1 * 1e12 + val2 * 1e12) / 1e12;
};

export default { formatEuroNumber, javascriptDecimalSum };
